import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import { settings } from "../../config/settings";
import ReactImageMagnify from 'react-image-magnify';
import Slider from "react-slick";

class Image extends React.PureComponent {

    render() {
        const { control, formid } = this.props;
        const data = this.props.data[formid] ? this.props.data[formid][control.key] : null;

        debugger;
        var ImageUrl = "";
        var _index = -1;
        if (Array.isArray(data) && control.sliderview) {
            var _settings = {
                dots: control.sliderpagination,
                customPaging: function (i) {
                    return (
                        <div>
                            <img width="100" height="100" alt={'Slide '+i} src={data[i]} />
                        </div>
                    );
                },
                dotsClass: "slick-dots slick-thumb",
                infinite: false,
                adaptiveHeight: true,
                slidesToShow: control.slidersize > 0 ? control.slidersize : 1,
                slidesToScroll: control.slidersize > 0 ? control.slidersize : 1,
                fade: control.fade,
                arrows: control.slidernavigation,
                className: control.centerClassName ? control.centerClassName : 'center',
                centerMode: control.centerMode === undefined ? false : control.centerMode,
                centerPadding: control.centerPadding ? (control.centerPadding + 'px') : '60px',
                rows: control.rows > 0 ? control.rows : 1,
                autoplay: control.autoplay === undefined ? false : control.autoplay,
                autoplaySpeed: control.autoplaySpeed ? control.autoplaySpeed : 2000,
                speed: control.speed ? control.speed : 500,
                swipeToSlide: control.swipeToSlide === undefined ? false : control.swipeToSlide,
                vertical: control.vertical,
                verticalSwiping: control.verticalSwiping,
                pauseOnHover: control.pauseOnHover
            };
            var sliderData = [];
            data.forEach((_imageUrl) => {
                sliderData.push({ 'image': _imageUrl, 'text': '' })
            })
            return (
                <React.Fragment>
                    {data.length > 0 ?
                        <div className='position-relative slick-slider-outer' style={{
                            maxWidth:control.imgwidth,
                            margin:'0 auto'
                            }}>
                            <div
                                id="zoom-portal"
                                className="portal"
                                style={{ position: 'absolute', left: '100%', marginLeft: 20, top: 0, zIndex: 99999, width:500,height:500 }}
                            />
                            <Slider {..._settings}>
                                {data.map((src, index) => {
                                    return (
                                        <div key={index}>
                                            <ReactImageMagnify
                                                {...{
                                                    smallImage: {
                                                        alt: 'Wristwatch by Versace',
                                                        isFluidWidth: true,
                                                        src: src,
                                                        srcSet: src,
                                                        //sizes: '(max-width: 480px) 100vw, (max-width: 1200px) 30vw, 360px'
                                                    },
                                                    largeImage: {
                                                        src: src,
                                                        width: control.largeImageWidth ? control.largeImageWidth : 1000,
                                                        height: control.largeImageHeight ? control.largeImageHeight : 1000
                                                    },
                                                    lensStyle: { backgroundColor: 'rgba(0,0,0,.6)' },
                                                    enlargedImagePortalId: 'zoom-portal',
                                                    enlargedImageContainerDimensions: {
                                                        width: '100%',
                                                        height: '100%'
                                                    }
                                                }}
                                            />
                                        </div>
                                    )
                                })
                                }
                            </Slider>
                        </div>
                        :
                        <img src={control.nodataimage} alt="No Data" className={control.class + ' ' + (control.circleimage ? ' rounded-circle' : '')} width={control.imgwidth} height={control.height} 
                        />
                    }
                </React.Fragment>
            )
        } else {
            if (control.isbase64string) {
                ImageUrl = data;
                if (!ImageUrl) {
                    ImageUrl = control.imageurl;
                }
            } else {
                const getIndex = (url) => {
                    var arr = typeof url == 'string' ? url.split('') : [];
                    arr.forEach((char, i) => {
                        if (/^[a-zA-Z]*$/g.test(char) && _index === -1) {
                            _index = i;
                            return false;
                        } else {
                            return true;
                        }
                    });
                    if (_index === -1) {
                        _index = 0;
                    }
                    return _index;
                }
                if (data && typeof data == 'string') {
                    if (data.indexOf("http") > -1) {
                        ImageUrl = data;
                    } else {
                        ImageUrl = (this.props.token.baseapiurl ? this.props.token.baseapiurl : settings.BASE_API_URL) + '/' + data.substring(getIndex(data));
                    }
                } else {
                    if (control.imageurl.indexOf("http") > -1) {
                        ImageUrl = control.imageurl;
                    } else {
                        ImageUrl = (this.props.token.baseapiurl ? this.props.token.baseapiurl : settings.BASE_API_URL) + '/' + control.imageurl.substring(getIndex(control.imageurl));
                    }
                }
            }
            if (!control.isbackgroundimage) {
                return (
                    <img src={ImageUrl} alt={control.label} className={control.class + ' ' + (control.circleimage ? ' rounded-circle' : '')} width={control.imgwidth} height={control.height} />
                );
            }
            else {
                return (
                    <div className={"img-bg " + control.class + ' ' + (control.circleimage ? ' rounded-circle' : '')} style={{ 'width': control.imgwidth, 'paddingTop': control.height, 'backgroundImage': 'url(' + ImageUrl + ')' }}></div>
                );
            }
        }
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value) => dispatch(updateFilterData(key, value))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});
export default connect(mapStateToProps, bindAction)(Image);